<cs-form-generator-nxt [data]="renderContext"
					   [autoSizing]="false"
					   [autoMaxWidth]="false"
					   [hideEmptyOptionalFields]="true">

</cs-form-generator-nxt>
